import React, { createContext, useContext, useState, ReactNode } from 'react';
import { UserRole } from '../types';

interface ModeContextType {
  currentMode: UserRole;
  switchMode: (mode: UserRole) => void;
  isClientMode: boolean;
  isFreelancerMode: boolean;
}

const ModeContext = createContext<ModeContextType | undefined>(undefined);

export const useMode = () => {
  const context = useContext(ModeContext);
  if (context === undefined) {
    throw new Error('useMode must be used within a ModeProvider');
  }
  return context;
};

interface ModeProviderProps {
  children: ReactNode;
}

export const ModeProvider: React.FC<ModeProviderProps> = ({ children }) => {
  // 기본값은 의뢰자 모드, localStorage에서 마지막 선택한 모드 복원
  const [currentMode, setCurrentMode] = useState<UserRole>(() => {
    try {
      const savedMode = localStorage.getItem('freematch-user-mode');
      return (savedMode as UserRole) || 'client';
    } catch {
      return 'client';
    }
  });

  const switchMode = (mode: UserRole) => {
    setCurrentMode(mode);
    // 선택한 모드를 localStorage에 저장
    try {
      localStorage.setItem('freematch-user-mode', mode);
    } catch (error) {
      console.error('모드 저장 실패:', error);
    }
    console.log(`모드 전환: ${mode === 'client' ? '의뢰자' : '전문가'} 모드`);
  };

  const value: ModeContextType = {
    currentMode,
    switchMode,
    isClientMode: currentMode === 'client',
    isFreelancerMode: currentMode === 'freelancer'
  };

  return (
    <ModeContext.Provider value={value}>
      {children}
    </ModeContext.Provider>
  );
};